export const products = [
  {
    id: 1,
    name: 'Aviator Prestige',
    price: 1329,
    originalPrice: 1599,
    image: 'https://i.ibb.co/271DJ6YD/austin-p-x-ro8-SEHw-Gw-unsplash.jpg',
    images: [
      'https://i.ibb.co/271DJ6YD/austin-p-x-ro8-SEHw-Gw-unsplash.jpg',
      'https://images.unsplash.com/photo-1511499767150-a48a237f0083?ixlib=rb-4.0.3&auto=format&fit=crop&w=1280&q=80',
      'https://i.ibb.co/9X2LxTb/giorgio-trovato-K62u25-Jk6vo-unsplash.jpg'
    ],
    reviews: 248,
    rating: 4.8,
    category: 'sunglasses',
    badge: 'Bestseller',
    discount: 17,
    description: 'The Aviator Prestige combines timeless design with modern craftsmanship. These premium sunglasses feature high-quality materials and superior UV protection, making them perfect for any occasion.',
    features: [
      '100% UV Protection',
      'Premium Metal Frame',
      'Polarized Lenses',
      'Lightweight Design',
      'Scratch Resistant',
      'Adjustable Nose Pads'
    ],
    specifications: {
      frameWidth: '140mm',
      lensWidth: '58mm',
      bridgeWidth: '14mm',
      templeLength: '145mm',
      weight: '28g',
      material: 'Titanium Alloy'
    },
    inStock: true,
    stockCount: 45,
    colors: ['Gold', 'Silver', 'Black'],
    sizes: ['Small', 'Medium', 'Large']
  },
  {
    id: 2,
    name: 'Metropolitan Frame',
    price: 1289,
    originalPrice: 1489,
    image: 'https://images.unsplash.com/photo-1511499767150-a48a237f0083?ixlib=rb-4.0.3&auto=format&fit=crop&w=1280&q=80',
    images: [
      'https://images.unsplash.com/photo-1511499767150-a48a237f0083?ixlib=rb-4.0.3&auto=format&fit=crop&w=1280&q=80',
      'https://i.ibb.co/271DJ6YD/austin-p-x-ro8-SEHw-Gw-unsplash.jpg',
      'https://i.ibb.co/mF8tGFhf/lucas-george-wendt-3xt-Ce-Uhq-ZWE-unsplash.jpg'
    ],
    reviews: 192,
    rating: 4.7,
    badge: 'New',
    category: 'frames',
    discount: 13,
    description: 'Contemporary frames that blend cutting-edge materials with minimalist design philosophy. Perfect for everyday wear with blue light protection for digital screens.',
    features: [
      'Blue Light Protection',
      'Prescription Ready',
      'Lightweight Acetate',
      'Flexible Hinges',
      'Anti-Glare Coating',
      'Student Discount Available'
    ],
    specifications: {
      frameWidth: '135mm',
      lensWidth: '52mm',
      bridgeWidth: '18mm',
      templeLength: '140mm',
      weight: '22g',
      material: 'Premium Acetate'
    },
    inStock: true,
    stockCount: 32,
    colors: ['Black', 'Tortoise', 'Clear'],
    sizes: ['Small', 'Medium', 'Large']
  },
  {
    id: 3,
    name: 'Artisan Round',
    price: 1459,
    originalPrice: 1699,
    image: 'https://i.ibb.co/9X2LxTb/giorgio-trovato-K62u25-Jk6vo-unsplash.jpg',
    images: [
      'https://i.ibb.co/9X2LxTb/giorgio-trovato-K62u25-Jk6vo-unsplash.jpg',
      'https://images.unsplash.com/photo-1511499767150-a48a237f0083?ixlib=rb-4.0.3&auto=format&fit=crop&w=1280&q=80',
      'https://i.ibb.co/271DJ6YD/austin-p-x-ro8-SEHw-Gw-unsplash.jpg'
    ],
    reviews: 312,
    rating: 4.9,
    category: 'sunglasses',
    badge: 'Student Fav',
    discount: 14,
    description: 'Handcrafted round sunglasses with vintage-inspired design. These artisan-made frames offer exceptional comfort and style for the discerning individual.',
    features: [
      'Handcrafted Design',
      'Vintage Inspired',
      'Premium Lenses',
      'Comfortable Fit',
      'UV400 Protection',
      'Eco-Friendly Materials'
    ],
    specifications: {
      frameWidth: '138mm',
      lensWidth: '50mm',
      bridgeWidth: '20mm',
      templeLength: '145mm',
      weight: '25g',
      material: 'Sustainable Acetate'
    },
    inStock: true,
    stockCount: 28,
    colors: ['Brown', 'Green', 'Blue'],
    sizes: ['Small', 'Medium']
  },
  {
    id: 4,
    name: 'Executive Titan',
    price: 1599,
    originalPrice: 1899,
    image: 'https://i.ibb.co/mF8tGFhf/lucas-george-wendt-3xt-Ce-Uhq-ZWE-unsplash.jpg',
    images: [
      'https://i.ibb.co/mF8tGFhf/lucas-george-wendt-3xt-Ce-Uhq-ZWE-unsplash.jpg',
      'https://i.ibb.co/9X2LxTb/giorgio-trovato-K62u25-Jk6vo-unsplash.jpg',
      'https://images.unsplash.com/photo-1511499767150-a48a237f0083?ixlib=rb-4.0.3&auto=format&fit=crop&w=1280&q=80'
    ],
    reviews: 176,
    rating: 4.6,
    badge: 'Limited',
    category: 'frames',
    discount: 16,
    description: 'Executive-level frames designed for professionals who demand excellence. Featuring titanium construction and sophisticated styling for the modern workplace.',
    features: [
      'Titanium Construction',
      'Professional Design',
      'Lightweight Comfort',
      'Prescription Compatible',
      'Lifetime Warranty',
      'Executive Collection'
    ],
    specifications: {
      frameWidth: '142mm',
      lensWidth: '55mm',
      bridgeWidth: '16mm',
      templeLength: '145mm',
      weight: '18g',
      material: 'Pure Titanium'
    },
    inStock: true,
    stockCount: 15,
    colors: ['Gunmetal', 'Silver', 'Black'],
    sizes: ['Medium', 'Large']
  },
  {
    id: 5,
    name: 'Classic Wayfarer',
    price: 1199,
    originalPrice: 1399,
    image: 'https://images.unsplash.com/photo-1574258495973-f010dfbb5371?ixlib=rb-4.0.3&auto=format&fit=crop&w=1280&q=80',
    images: [
      'https://images.unsplash.com/photo-1574258495973-f010dfbb5371?ixlib=rb-4.0.3&auto=format&fit=crop&w=1280&q=80',
      'https://i.ibb.co/271DJ6YD/austin-p-x-ro8-SEHw-Gw-unsplash.jpg'
    ],
    reviews: 89,
    rating: 4.5,
    category: 'sunglasses',
    badge: 'Classic',
    discount: 14,
    description: 'Timeless wayfarer design that never goes out of style. Perfect for casual and formal occasions with superior comfort and protection.',
    features: [
      'Classic Design',
      'All-Day Comfort',
      'UV Protection',
      'Durable Frame',
      'Versatile Style',
      'Affordable Luxury'
    ],
    specifications: {
      frameWidth: '145mm',
      lensWidth: '54mm',
      bridgeWidth: '18mm',
      templeLength: '150mm',
      weight: '30g',
      material: 'Acetate'
    },
    inStock: true,
    stockCount: 67,
    colors: ['Black', 'Brown', 'Navy'],
    sizes: ['Small', 'Medium', 'Large']
  },
  {
    id: 6,
    name: 'Sport Vision Pro',
    price: 1799,
    originalPrice: 2099,
    image: 'https://images.unsplash.com/photo-1556306535-38febf6782e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1280&q=80',
    images: [
      'https://images.unsplash.com/photo-1556306535-38febf6782e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1280&q=80',
      'https://i.ibb.co/9X2LxTb/giorgio-trovato-K62u25-Jk6vo-unsplash.jpg'
    ],
    reviews: 134,
    rating: 4.8,
    category: 'sunglasses',
    badge: 'Sport',
    discount: 14,
    description: 'High-performance sports eyewear designed for active lifestyles. Features advanced lens technology and secure fit for all activities.',
    features: [
      'Sport Performance',
      'Secure Fit',
      'Impact Resistant',
      'Sweat Resistant',
      'Enhanced Clarity',
      'Active Lifestyle'
    ],
    specifications: {
      frameWidth: '140mm',
      lensWidth: '65mm',
      bridgeWidth: '12mm',
      templeLength: '125mm',
      weight: '26g',
      material: 'TR90 Polymer'
    },
    inStock: true,
    stockCount: 23,
    colors: ['Black', 'Red', 'Blue'],
    sizes: ['Medium', 'Large']
  }
];

// Add kids products to the main products array for product detail functionality
export const kidsProducts = [
  {
    id: 101,
    name: 'Rainbow Explorer',
    price: 899,
    originalPrice: 1099,
    image: 'https://images.unsplash.com/photo-1574258495973-f010dfbb5371?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    images: [
      'https://images.unsplash.com/photo-1574258495973-f010dfbb5371?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1511499767150-a48a237f0083?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    ],
    reviews: 156,
    rating: 4.9,
    category: 'kids-sunglasses',
    badge: 'Super Cool!',
    discount: 18,
    description: 'Colorful sunglasses that make every adventure more fun! Perfect for active kids who love to explore the world with style and safety.',
    features: [
      '100% UV Protection',
      'Flexible TR90 Frame',
      'Fun Rainbow Colors',
      'Comfortable All-Day Fit',
      'Impact Resistant',
      'Easy to Clean'
    ],
    specifications: {
      frameWidth: '120mm',
      lensWidth: '45mm',
      bridgeWidth: '16mm',
      templeLength: '125mm',
      weight: '15g',
      material: 'Flexible TR90'
    },
    colors: ['Rainbow', 'Pink', 'Blue'],
    sizes: ['XS', 'S'],
    ageRange: '3-8 years',
    inStock: true,
    stockCount: 25
  },
  {
    id: 102,
    name: 'Super Hero Specs',
    price: 799,
    originalPrice: 999,
    image: 'https://images.unsplash.com/photo-1556306535-38febf6782e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    images: [
      'https://images.unsplash.com/photo-1556306535-38febf6782e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    ],
    reviews: 203,
    rating: 4.8,
    category: 'kids-frames',
    badge: 'Hero Power!',
    discount: 20,
    description: 'Transform into your favorite superhero with these awesome frames! Designed for young heroes who need clear vision for their adventures.',
    features: [
      'Blue Light Filter',
      'Durable Hero Design',
      'Superhero Colors',
      'Easy Clean Surface',
      'Prescription Ready',
      'Impact Resistant'
    ],
    specifications: {
      frameWidth: '125mm',
      lensWidth: '48mm',
      bridgeWidth: '18mm',
      templeLength: '130mm',
      weight: '18g',
      material: 'Impact Resistant Acetate'
    },
    colors: ['Red', 'Blue', 'Green'],
    sizes: ['XS', 'S', 'M'],
    ageRange: '5-12 years',
    inStock: true,
    stockCount: 18
  },
  {
    id: 103,
    name: 'Princess Sparkle',
    price: 849,
    originalPrice: 1049,
    image: 'https://images.unsplash.com/photo-1574258495973-f010dfbb5371?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    images: [
      'https://images.unsplash.com/photo-1574258495973-f010dfbb5371?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    ],
    reviews: 89,
    rating: 4.7,
    category: 'kids-sunglasses',
    badge: 'Magical!',
    discount: 19,
    description: 'Sparkly frames fit for a princess or prince! These magical glasses add a touch of wonder to every day.',
    features: [
      'Glitter Design',
      '100% UV Protection',
      'Comfortable Fit',
      'Magical Sparkle Look',
      'Lightweight Design',
      'Easy Care'
    ],
    specifications: {
      frameWidth: '118mm',
      lensWidth: '44mm',
      bridgeWidth: '15mm',
      templeLength: '120mm',
      weight: '14g',
      material: 'Sparkle Acetate'
    },
    colors: ['Pink', 'Purple', 'Gold'],
    sizes: ['XS', 'S'],
    ageRange: '4-10 years',
    inStock: true,
    stockCount: 32
  },
  {
    id: 104,
    name: 'Space Adventure',
    price: 929,
    originalPrice: 1129,
    image: 'https://images.unsplash.com/photo-1511499767150-a48a237f0083?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    images: [
      'https://images.unsplash.com/photo-1511499767150-a48a237f0083?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    ],
    reviews: 124,
    rating: 4.8,
    category: 'kids-frames',
    badge: 'Cosmic!',
    discount: 18,
    description: 'Blast off to space with these out-of-this-world frames! Perfect for young astronauts and space explorers.',
    features: [
      'Space-Themed Design',
      'Blue Light Filter',
      'Glow-in-Dark Effects',
      'Adventure Ready',
      'Prescription Compatible',
      'Durable Construction'
    ],
    specifications: {
      frameWidth: '130mm',
      lensWidth: '50mm',
      bridgeWidth: '17mm',
      templeLength: '135mm',
      weight: '20g',
      material: 'Cosmic Polymer'
    },
    colors: ['Galaxy', 'Silver', 'Black'],
    sizes: ['S', 'M'],
    ageRange: '6-12 years',
    inStock: true,
    stockCount: 21
  }
];

// Combine all products for unified access
const allProducts = [...products, ...kidsProducts];

export const getProductById = (id) => {
  return allProducts.find(product => product.id === parseInt(id));
};

export const getProductsByCategory = (category) => {
  if (category.startsWith('kids')) {
    return kidsProducts.filter(product => product.category === category);
  }
  return products.filter(product => product.category === category);
};

export const getFeaturedProducts = () => {
  return products.filter(product => ['Bestseller', 'New', 'Student Fav'].includes(product.badge));
};

export const getKidsProducts = () => {
  return kidsProducts;
};